module.exports = __webpack_public_path__ + "static/img/revision_icon.c54b120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/revision_icon.svg
// module id = t0tb
// module chunks = 1